import { SeriesOption } from 'echarts';
import CycleMeasurement from '../../enums/cycle-measurement';
import { ControllerItemType } from '../../enums/controller-item-type';

export const LTTB_ALGORITM_1920 = 1920;
export const LTTB_ALGORITM_3000 = 3000;
export const LTTB_ALGORITM_5000 = 5000;

export const GET_LTTB_DATA_STEP_1 = 100000
export const GET_LTTB_DATA_STEP_2 = 30000
export const GET_LTTB_DATA_STEP_3 = 10000

export const Y_AXIS_RANGE= {
  [CycleMeasurement.Celsius]: {
    MIN: -40,
    MAX: 1316,
  },
  [CycleMeasurement.Fahrenheit]: {
    MIN: -40,
    MAX: 2400,
  },
};

export const Y_AXIS_PADDING = 40;

export const DATA_ZOOM_ID = {
  SLIDER_X: 'SLIDER_X',
  SLIDER_Y: 'SLIDER_Y',
  INSIDE_X: 'INSIDE_X',
  INSIDE_Y: 'INSIDE_Y',
};
export const DATA_ZOOM = {
  X: {
    MIN_SPAN: 1,
    MAX_SPAN: 100
  },
  Y: {
    MIN_SPAN: 1,
    MAX_SPAN: 100
  }
};
export const CHART_INDENTS = {
  GRID: {
    LEFT: 80,
    RIGHT: 60,
    BOTTOM: 100,
    TOP: 48,
  },
  SLIDER: {
    [DATA_ZOOM_ID.SLIDER_Y]: {
      RIGHT: 10,
    },
    [DATA_ZOOM_ID.SLIDER_X]: {
      BOTTOM: 30,
      RIGHT: 8,
      LEFT: 8,
    }
  }
};
export const DEFAULT_INDENT = { START: 0, END: 100 };
export const WIDTH_HEIGHT_SLIDER = 20;
export const CLASS_NAME_SPACE = {
  LEFT: 'before:content-[\'\'] before:pointer-events-none before:absolute before:block before:h-full before:w-[80px] before:z-1',
  RIGHT: 'after:content-[\'\'] after:w-[60px] after:pointer-events-none after:absolute after:block after:h-full after:z-1 after:right-0 after:top-0',
  TOP: 'before:absolute before:block before:w-full before:h-[20px] before:z-1',
  BOTTOM: 'after:content-[\'\'] after:w-full after:h-[100px] after:pointer-events-none after:absolute after:block after:z-1 after:right-0 after:bottom-0',
};
export const DEFAULT_Y_AXIS_ZOOM_SLIDER_MARGIN_BY_CELSIUS: number = 20;
export const X_AXIS: {
  BOTTOM: {
    INDEX: number;
    ID: string;
    SERIES_OPTIONS: Partial<SeriesOption>;
  };
  TOP: {
    INDEX: number;
    ID: string;
    SERIES_OPTIONS: Partial<SeriesOption>;
  };
} = {
  BOTTOM: {
    INDEX: 0,
    ID: 'BOTTOM',
    SERIES_OPTIONS: {
      xAxisId: 'BOTTOM',
    }
  },
  TOP: {
    INDEX: 1,
    ID: 'TOP',
    SERIES_OPTIONS: {
      xAxisId: 'TOP',
      tooltip: { show: false },
      showSymbol: false,
      symbolSize: 0,
      itemStyle: { opacity: 0 },
      symbol: 'none',
      lineStyle: {
        opacity: 0,
      },
      color: '',
    }
  }
}
export const CHARACTER_SEPARATOR_IOT_KEY_NAME = '#';
export const CHARACTER_SEPARATOR_DEVICE_NAME = '-';
export const DEVICE_NAME = {
  C: 'Channel',
  TC: 'Thermocouple',
};
export const IOT_DEVICE_TYPE = {
  [ControllerItemType.CHANNEL]: 'C',
  [ControllerItemType.THERMOCOUPLE]: 'TC',
};

export const SPLIT_NUMBER = 5;

export const SET_POINT_NAME = 'SP';

export const NOTE_ID = 'NOTE'

export const AXIS_CONFIG = {
  TIME: {
    BOTTOM: {
      formatter: '{HH}:{mm}',
      color: '#000',
      rotate: 90,
    },
    TOP: {
      formatter: '{dd}-{MMM}',
      color: '#000',
      rotate: -20,
    },
  },
  SPLIT_LINE: {
    show: true,
    interval: 0,
    lineStyle: {
      color: '#e0e0e0',
    },
  },
};
